export const POLL_MS = 1500;

const BUSY: Record<'thought' | 'draft' | 'eval', ReadonlyArray<string>> = {
  thought: ['transcribing', 'ideating'],
  draft: ['writing', 'editing'],
  eval: ['running'],
};

/** react-query `refetchInterval`: poll while a background job runs, stop otherwise. */
export function busyInterval(kind: 'thought' | 'draft' | 'eval', status: string | undefined): number | false {
  return status !== undefined && BUSY[kind].includes(status) ? POLL_MS : false;
}
